import { Flower2 } from "lucide-react";
import { MARQUEE_ITEMS } from "@/data/site";

export default function Marquee() {
    const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
    return (
        <div data-testid="marquee" className="relative overflow-hidden border-y border-[#D4AF37]/25 bg-[#FDF0F4] py-5">
            <div className="animate-marquee flex w-max items-center gap-10 pr-10">
                {items.map((item, i) => (
                    <span key={i} className="flex items-center gap-10 whitespace-nowrap">
                        <span className={`font-display text-lg sm:text-xl italic text-[#6B4A3E] ${i % 2 ? "font-script not-italic text-2xl text-[#C95B7D]" : ""}`}>
                            {item}
                        </span>
                        <Flower2 className="h-4 w-4 shrink-0 text-[#C59B27]" />
                    </span>
                ))}
            </div>
        </div>
    );
}
